// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconFoodBeveragesPath = 'M12 18a6.01 6.01 0 0 1-5.917-5h11.834A6.01 6.01 0 0 1 12 18Zm-9 0a1 1 0 0 1-1-1V9.92c0-.292.203-.521.324-.632 1.039-.954 1.436-2.313 1.588-3.317a2.587 2.587 0 0 0-.679-2.15C3.146 3.729 3 3.549 3 3.393V3h4v.41c0 .145-.137.31-.218.395a2.614 2.614 0 0 0-.69 2.196c.148.974.545 2.333 1.585 3.287.12.111.323.34.323.632V11H4v1a7.975 7.975 0 0 0 2.727 6H3Zm12.414-7 4.293-4.293-1.414-1.414L12.586 11H10V9.92c0-.784-.346-1.532-.973-2.107-.642-.588-.877-1.578-.959-2.119a.593.593 0 0 1 .161-.507C8.733 4.658 9 4.043 9 3.41V1H1v2.393c0 .636.269 1.257.776 1.798a.6.6 0 0 1 .164.408c-.001.042-.007.088-.008.099-.082.537-.317 1.527-.958 2.115C.346 8.388 0 9.136 0 9.92V17c0 1.654 1.346 3 3 3h9c4.411 0 8-3.589 8-8v-1h-4.586Z';
var IconFoodBeverages = baseIcon('IconFoodBeverages', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconFoodBeveragesPath
});
export default IconFoodBeverages;
//# sourceMappingURL=index.js.map